import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function CustomerSidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/customer-login');
  };

  const menuSections = [
    {
      title: 'Management',
      links: [
        { label: 'Company', icon: '🏢', to: '/customer/company' },
        { label: 'User', icon: '👥', to: '/customer/users' }
      ]
    },
    {
      title: 'GatePass',
      links: [
        { label: 'New', icon: '🆕', to: '/customer/gatepass/new' },
        { label: 'Show', icon: '📋', to: '/customer/gatepass/show' },
        { label: 'Reports', icon: '📈', to: '/customer/gatepass/reports' }
      ]
    },
    {
      title: 'Configuration',
      links: [
        { label: 'WABA', icon: '💬', to: '/customer/config/waba' },
        { label: 'Email', icon: '📧', to: '/customer/config/email' }
      ]
    },
    {
      title: 'Profile',
      links: [
        { label: 'Current User', icon: '👤', to: '/customer/profile' }
      ]
    }
  ];

  return (
    <div className="bg-dark text-white d-flex flex-column p-3 vh-100" style={{ minWidth: '240px' }}>
      <div className="text-center mb-4">
        <h5 className="fw-bold">Customer Menu</h5>
      </div>

      {menuSections.map((section, index) => (
        <div className="mb-4" key={index}>
          <div className="text-uppercase text-secondary small fw-bold px-2">
            {section.title}
          </div>
          <ul className="nav flex-column mt-2">
            {section.links.map((item, idx) => (
              <li key={idx} className="nav-item">
                <Link to={item.to} className="nav-link text-white px-3 py-2 rounded hover-opacity d-flex align-items-center">
                  <span className="me-2">{item.icon}</span> {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <div className="mt-auto">
        <button className="btn btn-outline-light w-100" onClick={handleLogout}>
          🚪 Logout
        </button>
      </div>
    </div>
  );
}

export default CustomerSidebar;
